export const SAVE_STATE_VALIDATION_VALIDATE = 'SAVE_STATE_VALIDATION_VALIDATE';
export const SAVE_STATE_VALIDATION_RESULT = 'SAVE_STATE_VALIDATION_RESULT';
